/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";

function Hero() {
  return (
    <div className="container border-bottom mb-5">
      <div className="row text-center mt-5 p-3">
        <h1>Zerodha Products</h1>
        <h4 className="fs-4 text-muted mt-3">
          {" "}
          Sleek, modern, and intuitive trading platforms
        </h4>
        <p className="mt-3 mb-5">
          Check out our{" "}
          <a href="" className="" style={{ textDecoration: "none" }}>
            {" "}
            investment offerings{" "}
            <i class="fa fa-long-arrow-right" aria-hidden="true"></i>
          </a>
        </p>
      </div>
    </div>
  );
}

export default Hero;
